<template>
    <div id="app">
        <v-app id="inspire">
            <v-card  v-if="details">
                <v-container fluid class="pa-0" grid-list-md>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs7>
                            <v-card-title class="title font-weight-black"> 
                                {{transactionDetails.branch}}
                            </v-card-title> 
                        </v-flex>

                        <v-flex xs5>
                            <v-card-title class="title font-weight-black"> 
                                Job Order No.: <span class="title font-weight-black red--text pl-2"> {{ details.transactionId}}</span>
                            </v-card-title> 
                        </v-flex>
                    </v-layout>

                    <v-divider></v-divider>

                    <v-layout wrap> 
                        <v-flex xs4>
                            <v-card-title class="subtitle-1 font-weight-black pb-0"> 
                                Owner: <span class="subtitle-1 font-weight-regular pl-2">{{transactionDetails.customerName}}</span>
                            </v-card-title>

                            <v-card-title class="subtitle-1 font-weight-black pb-0 pt-0 "> 
                                Address: <span class="subtitle-1 font-weight-regular pl-2">{{details.address}}</span>
                            </v-card-title>

                            <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                Date of Purchase: 
                            </v-card-title>

                            <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                Registration No.: 
                            </v-card-title>

                            <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                Time In: <span class="subtitle-1 font-weight-regular pl-2">{{details.timeIn}}</span>

                            </v-card-title> <v-card-title class="subtitle-1 font-weight-black pt-0 pb-3"> 
                                Time out: <span class="subtitle-1 font-weight-regular pl-2">{{details.timeOut}}</span>
                            </v-card-title>
                        </v-flex>

                        <v-flex xs4>
                             <v-card-title class="subtitle-1 font-weight-black pb-0"> 
                                Dealer: <span class="subtitle-1 font-weight-regular pl-2">{{details.dealer}}</span>
                            </v-card-title>

                            <v-card-title class="subtitle-1 font-weight-black pb-0 pt-0"> 
                                Model: <span class="subtitle-1 font-weight-regular pl-2">{{details.model}}</span>
                            </v-card-title>

                            <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                Engine Number: <span class="subtitle-1 font-weight-regular pl-2">{{details.engineNumber}}</span>
                            </v-card-title>

                            <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                Frame Number: <span class="subtitle-1 font-weight-regular pl-2">{{details.chassisNumber}}</span>
                            </v-card-title>

                            <v-card-title class="subtitle-1 font-weight-black pt-0 pb-0"> 
                                Plate Number: <span class="subtitle-1 font-weight-regular pl-2">{{details.plateNumber}}</span>
                            </v-card-title>

                            <v-card-title class="subtitle-1 font-weight-black pt-0 pb-3"> 
                                Mileage: <span class="subtitle-1 font-weight-regular pl-2">{{details.odometer}}</span>
                            </v-card-title>
                        </v-flex>

                        <v-flex xs4 class="pt-4">
                            <v-text-field label="Approved by: " required hide-details readonly :value="details.approvedBy"></v-text-field>

                            <v-text-field label="Tested by:" placeholder="Please Specify" required readonly
                            :value="details.mechanic"></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-divider></v-divider>
                    
                    <v-layout>
                        <v-flex xs8>
                            <v-layout v-for="(service,index) in transactionDetails.initialService" :key="index">
                                <v-flex xs8>
                                    <v-text-field label="Work Requested" placeholder="Please Specify" required  readonly :value="service.service"></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field type="number" label="Labor Charge" placeholder="Please Specify" required :value="service.price"></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout wrap v-for="(service,index) in transactionDetails.otherService" :key="index">
                                <v-flex xs8>
                                    <v-text-field label="Others" placeholder="Please Specify" required readonly :value="service.service"></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field type="number" label="Labor Charge" placeholder="Please Specify" required :value="service.price"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex xs4>
                            <v-text-field label="Invoice No.: " readonly required hide-details :value="details.invoice"></v-text-field>

                            <v-text-field label="Date: " required hide-details readonly :value="transactionDetails.appointmentDate"></v-text-field>  

                            <v-textarea label="Remarks: " required hide-details :value="details.joRemarks"></v-textarea> 

                            <v-text-field label="Validated by: " required hide-details readonly :value="details.cashier" class="pb-4"></v-text-field>

                             <span class="subtitle-1 font-weight-regularodbb">Received the above described motorcycle in good order and condition, and hereby certify that repairs have been made to my complete satisfaction</span>

                            <v-text-field readonly required hide-details></v-text-field> 
                            <span class="subtitle-1 font-weight-regular">Customer/Authorized Representative</span>
                        </v-flex>
                    </v-layout>

                    <v-divider></v-divider>
                    
                    <v-card-title class="title font-weight-black pt-2 pb-0"> 
                        Total: {{transactionDetails.estimateCharge}}
                    </v-card-title>
                        
                </v-card-text>

                </v-container>
            </v-card>
        </v-app>
    </div>
</template>

<script>
import _ from 'lodash'
import store from '../stores'
import firebase from "firebase";
import {db} from '../main'
import parent from './AdminLayout'
import { mapGetters, mapState } from "vuex";
import { gmapApi } from "vue2-google-maps";
import { setTimeout } from 'timers';
import { functions } from 'firebase';
import { stage } from '../../appConfig';

export default {
    data: () => ({
        details: null,
        transactionDetails: null
    }),

    methods : {
        fetchDetails() {
            let self = this
            if (self.details) {
                db.collection("ServiceBooking"+self.$stage).doc(self.details.transactionId)
                    .get().then(function(doc) {
                        if (doc.exists) {
                            self.transactionDetails = doc.data()
                        }
                    }).then(function() {
                       window.print()
                    })
            }
        }
      
    },

    mounted() {
        let self = this 
        self.details = this.$route.query
        this.fetchDetails()
        
    },

    computed: {
        google: gmapApi,
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },

    watch: {
        
    },

}
</script>
